<div class="help-card-container" ngbDropdown #helpDrop="ngbDropdown">
  <div class="help-card" id="helpCard" ngbDropdownToggle>
    <a href="javascript:void(0)">
      <img src="assets/images/logos/help-icon.svg" alt="Help Icon">
    </a>
  </div>
  <div ngbDropdownMenu aria-labelledby="helpCard">
    <div class="dd-menu-header">Help</div>
    <div class="dd-menu-separator"></div>

    @if (helpExternal()) {
    <button class="dd-menu-item" (click)="helpCentre()" ngbDropdownItem>Help Center</button>
    } @else {
    <button class="dd-menu-item" (click)="helpCentreLocal()" ngbDropdownItem>Help Center</button>
    }
    

    <button class="dd-menu-item" (click)="contactSupport()" ngbDropdownItem>Contact Support</button>

  </div>
</div>
